module.exports = __webpack_public_path__ + "static/img/bg-es.11ce6458.png";